import { render, staticRenderFns } from "./zhongyaoyinpian.vue?vue&type=template&id=8f68a30c&scoped=true&"
import script from "./zhongyaoyinpian.vue?vue&type=script&lang=ts&"
export * from "./zhongyaoyinpian.vue?vue&type=script&lang=ts&"
import style0 from "./zhongyaoyinpian.vue?vue&type=style&index=0&id=8f68a30c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f68a30c",
  null
  
)

export default component.exports